import { call, fork, put, take } from 'redux-saga/effects';
import { takeEvery, eventChannel } from 'redux-saga';
import NotificationClient from '../../../websockets/NotificationClient';
import * as actions from './actions';

const RECONNECT_TIMEOUT = 5000;

export function wait(timeout) {
	return new Promise(resolve => setTimeout(resolve, timeout));
}

export function createChannel(client) {
	return eventChannel(emit => {
		client.onStatus(status => {
			// we only have one type of status message at the moment
			// istanbul ignore else
			if (status.type === 'badge') {
				emit(actions.updateNavigationBadge(status));
			}
		});
		client.onError(() => {
			emit(actions.disconnectNotifications(client));
		});
		client.onClose(() => {
			emit(actions.disconnectNotifications(client));
		});
		return () => {
			// remove the subscriptions
			client.unregisterEventListeners();
		};
	});
}

export function connectChannel(client) {
	return client.connect();
}

export function *startNotifications() {
	let client;
	let channel;
	try {
		client = new NotificationClient();
		channel = yield call(createChannel, client);
		yield call(connectChannel, client);

		while (true) {
			const action = yield take(channel);
			yield put(action);
		}
	} catch (ex) {
		yield put(actions.disconnectNotifications(client));
	}
}

export function *disconnectNotifications({ payload: client }) {
	try {
		client.disconnect();
	} catch (ex) {
		// gobble
	}
	yield call(wait, RECONNECT_TIMEOUT);
	yield put(actions.connectToNotifications());
}

export default function *sagas() {
	yield fork(takeEvery, actions.NOTIFICATIONS_CONNECT, startNotifications);
	yield fork(takeEvery, actions.NOTIFICATIONS_DISCONNECT, disconnectNotifications);
}
